export const joutneyData = [
    {
        uuid: "main",
        ident: "journey",
        stories: [
            {
                uuid: "1",
                ident: "intro",
                delay: 3,
                scene: 0,
                page: 0,
            },
            {
                uuid: "2",
                ident: "blue-1",
                delay: 3,
                scene: 1,
                page: 0,
            },
            {
                uuid: "3",
                ident: "blue-2",
                delay: 3,
                scene: 1,
                page: 1,
            },
            {
                uuid: "4",
                ident: "blue-3",
                delay: 3,
                scene: 1,
                page: 2,
            },
            {
                uuid: "5",
                ident: "blue-4",
                delay: 3,
                scene: 1,
                page: 3,
            },
            {
                uuid: "6",
                ident: "red-1",
                delay: 3,
                scene: 2,
                page: 0,
            },
            {
                uuid: "7",
                ident: "red-2",
                delay: 3,
                scene: 2,
                page: 1,
            },
            {
                uuid: "8",
                ident: "red-3",
                delay: 3,
                scene: 2,
                page: 2,
            },
            {
                uuid: "9",
                ident: "gold-1",
                delay: 3,
                scene: 4,
                page: 0,
            },
        ],
    },
];

